/**
 * Firt page when there is no language selected by the url
 * 
 * Displyas the language selection links or in case of app-main-mode-repeat-visit mode
 * check what language was selected last time and redirect to the repeat visit start page
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import TopNav from  '../PatientApp/TopNav';

import StateMachine from 'react-simple-state/dist';
import { ca } from 'date-fns/locale';
const appState = new StateMachine();

const LanguageChoosePage = ( props ) => {
  const navigate = useNavigate();
  
  const handleLanguageSelect = ( lang  ) => {
    navigate('/' + lang + '/start');
    return false;
  } 
  
  return (
    <div className="app-page landing">
      <LanguageChoosePageClass onLanguageSelect={handleLanguageSelect} sessionStillLoading={props.sessionStillLoading} />
    </div>
  );
}


class LanguageChoosePageClass extends React.Component {

  constructor( props ) {
    super( props );

    this.state = {
      "forceRenderCnt" : 1
    }

    this._isMounted = false;
    
    this.handleLanguageSelectClick = this.handleLanguageSelectClick.bind(this);
  }


  componentDidMount() {
    this._isMounted = true;
    var that = this;

    appState.subscribe( 'app-main-mode', this, ( newAppMainMode ) => {
      if( that._isMounted ){
        let next = ( that.state.forceRenderCnt + 1 );
        that.setState({
          "forceRenderCnt": next
        });
      }
    });
  }


  handleLanguageSelectClick( languageCode ) {
    this.props.onLanguageSelect( languageCode );
    return false;
  }
  
  componentWillUnmount() {
    this._isMounted = false;
  }


  render() {
    var that = this;

    let showUaHeart = false;

    let currentMode = appState.getState( 'app-main-mode' );
    if( currentMode.appMainMode === "app-main-mode-ukrainan" ){
      showUaHeart = true;
    }
    

    if( this.props.sessionStillLoading ){
      return (
        <div className="app-fragment app-fragment-app-loading">  
          <div>
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
          </div>
        </div>
      );
    }

    return (
      <div>
        
        <TopNav showLanguageLinks={false} />
        
        <div className="app-fragment pull-bottom-fixed">  
          
          {showUaHeart && (
            <span className="icon-ua-heart mb-6" ></span>
          )}

          <div className="text-links">
            {!showUaHeart && (
            <div className="text-link" onClick={ function(){ that.handleLanguageSelectClick( "et" ) } } >
              <div className="text">Vaimse tervise enesehindamine</div>
              <div className="arrow-right"></div>
            </div>
            )}
            
            {showUaHeart && (
              <div className="text-link" onClick={ function(){ that.handleLanguageSelectClick( "uk" ) } } >
                <div className="text">Самооцінка душевного здоров'я</div>
                <div className="arrow-right"></div>
              </div>
            )}
            <div className="text-link" onClick={ function(){ that.handleLanguageSelectClick( "ru" ) } } >
              <div className="text">Самооценка душевного здоровья</div>
              <div className="arrow-right"></div>
            </div>
            <div className="text-link" onClick={ function(){ that.handleLanguageSelectClick( "en" ) } } >
              <div className="text">Mental health self-assessment</div>
              <div className="arrow-right"></div>
            </div>
          </div>

          
          <div className="text-base text-white" style={{"textAlign": "left", "color" : "#bbbbbb"}}>
            © Documental OÜ {/* 2017 - 2023 */}
          </div>

        </div>
      </div>
    );
  }

}

export default LanguageChoosePage;